import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import { getHidePageContent, hidePageContentToggle } from "../../redux/slices/userSlice";

export default function PageHideToggle() {
  const dispatch = useAppDispatch();
  const hidePageContent = useAppSelector(getHidePageContent);

  const handleToggle = () => {
    dispatch(hidePageContentToggle(!hidePageContent));
  };

  return (
    <Tooltip title={hidePageContent ? "Show sidebar content" : "Hide sidebar content"}>
      <IconButton
        id="page-hide-toggle"
        onClick={handleToggle}
        size="medium"
        color="primary"
        sx={{
          backgroundColor: (theme) => 
            theme.palette.mode === "dark" ? "rgba(66, 66, 66, 0.5)" : "rgba(255, 255, 255, 0.7)",
          borderRadius: "40%",
          padding: "5px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          border: (theme) => `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)"}`,
          "&:hover": {
            backgroundColor: (theme) => 
              theme.palette.mode === "dark" ? "rgba(66, 66, 66, 0.8)" : "rgba(255, 255, 255, 0.9)",
          }
        }}
      >
        {hidePageContent ? <ChevronLeftIcon /> : <ChevronRightIcon /> }
      </IconButton>
    </Tooltip>
  );
}
